import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { ResponseTableElectoralCardData } from 'shell/models/electoral-card';
import {
  FiltersFormTableElectoralCard,
  TableElectoralCardBody,
} from 'front-office/view-models/electoral-card';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { Operation } from 'shell/view-models/operation';

export const transformerTableElectoralCardData = (
  response: AxiosResponse<HttpResponseListPayloadQuarkus<ResponseTableElectoralCardData>>
): Array<TableElectoralCardBody> => {
  const bodyTable: Array<TableElectoralCardBody> = (response.data.payload || []).map((item) => {
    return {
      number: item.key?.numero?.toString() || '',
      owner: item.personaSipo?.cognomeNome || '',
      service: item.servizio || '',
      operator: item.nomeCognomeOperatore || '',
      hourRelease: item.oraEmissione ? DateTime.fromISO(item.oraEmissione).toFormat('HH:mm') : '',
      dateRelease: item.dataEmissione
        ? DateTime.fromISO(item.dataEmissione).toFormat('dd/MM/yyyy')
        : '',
    };
  });

  return bodyTable || [];
};

export const transformDataset = (values: FiltersFormTableElectoralCard): string => {
  let service = '';

  if (values?.serviceCode) {
    service = values?.serviceCode;
  } else if (!values?.service || values?.service === 'TUTTI') {
    service = '';
  } else {
    service = values?.service;
  }

  let operator = '';

  if (values?.operatorCode) {
    operator = values?.operatorCode;
  } else if (!values?.operator || values?.operator === 'ALL') {
    operator = '';
  } else {
    operator = values?.operator;
  }

  const transformedFilters: OperationObject = {
    servizio: {
      value: service,
      operation: Operation.EQUALS,
    },
    operatore: {
      value: operator,
      operation: Operation.EQUALS,
    },
    dataRilascioDa: {
      value: values?.dateFrom ? values.dateFrom.toFormat('yyyyMMdd') : '',
      operation: Operation.EQUALS,
    },
    dataRilascioA: {
      value: values.dateTo ? values?.dateTo.toFormat('yyyyMMdd') : '',
      operation: Operation.EQUALS,
    },
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: {},
    page: values.page,
    rowsPerPage: values.rowsPerPage,
  })}`;
};
